import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, TypographyProps } from '@mui/material';

import { Icon } from '@components/base';
import { Series } from '@models/Title';

type SeriesCountDisplayProps = Omit<TypographyProps, 'color'> & {
  series?: Series;
};

export const SeriesCountDisplay: FC<SeriesCountDisplayProps> = ({
  alignItems = 'center',
  display = 'flex',
  gap = 0.5,
  gutterBottom = true,
  lineHeight = 'normal',
  series,
  variant = 'body2',
  ...typographyProps
}) => {
  const { t } = useTranslation();

  if (!series) return null;

  const { episodeCount = 0, seasonCount = 0 } = series || {};

  const missing = !(episodeCount && seasonCount);

  const seriesCountStr = [
    t('series.seasonCount', { count: seasonCount ?? 0 }),
    t('series.episodeCount', { count: episodeCount ?? 0 }),
  ].join(' / ');

  return (
    <Typography
      alignItems={alignItems}
      color={missing ? 'error' : undefined}
      display={display}
      gap={gap}
      gutterBottom={gutterBottom}
      lineHeight={lineHeight}
      variant={variant}
      {...typographyProps}
    >
      {missing && <Icon color='inherit' fontSize='inherit' name='error' />}
      {seriesCountStr}
    </Typography>
  );
};
